// FLAGS: none
// Maps the active i18n language onto a date-fns locale for the date pickers. Any language other than English
// resolves to Dutch, including the default branch, so an unmapped locale formats dates as nl-NL rather than en-GB.
import { enGB, nl } from "date-fns/locale";
import i18n from "./i18n";

const DateFnslocaleMapper = () => {
  switch (i18n.language) {
    case "nl":
    case "nl-NL":
      return nl;
    case "en":
    case "en-GB":
      return enGB;
    default:
      return nl;
  }
};

export { DateFnslocaleMapper };
